module.exports = __webpack_public_path__ + "img/icon-ranking.bfa94cf4.png";